import { resetFacility } from 'app/redux/profile/facility/actions';
import { store } from 'app/redux/store';
import { getLoginUrl } from './getLoginUrl';

/**
 * Redirects the user to the login page and resets the facility in the store.
 */
export function redirectToLogin() {
  store.dispatch(resetFacility());
  window.location.href = getLoginUrl();
}
